import Vue from 'vue';
import Router from 'vue-router';

import Home from 'pages/Home';// 一级路由
import Product from 'pages/product';// 二级路由

Vue.use(Router);

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    children: [
      {
        name: 'home-product',
        path: 'product/:id',
        component: Product
      }
    ]
  },
  {
    path: '*', // 路径/任意路由
    redirect: '/home'// 跳转路径
  }
];

export default new Router({
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js